import { Component, OnInit } from '@angular/core';
import { IEntityListComponentMembers, IEntityListDynamicCellComponentGeneric } from '@mt-ng2/entity-list-module';
import { IRegistrationRequest } from '../../model/interfaces/registration-request';
import { CustomerService } from '../../customers/customer.service';
import { RegistrationRequestService } from '../registration-request.service';
import { NotificationsService } from '@mt-ng2/notifications-module';
import { ModalService } from '@mt-ng2/modal-module';
import { ICustomer } from '../../model/interfaces/customer';

@Component({
    template: `
        <div (click)="$event.stopPropagation()">
            <select 
                class="form-control"
                style="min-width: 200px; font-size: 14px; height: 38px;"
                [value]="entity.CustomerId || 0"
                (change)="onCustomerChange($event)"
                [disabled]="entity.CarrierId > 0">
                <option value="0">-- Select Customer --</option>
                <option *ngIf="shouldShowCurrentCustomer()" 
                        [value]="entity.CustomerId" 
                        [selected]="true">
                    {{entity.Customer?.Name || 'Current Customer'}}
                </option>
                <option *ngFor="let customer of customers" [value]="customer.Id" [selected]="customer.Id === entity.CustomerId">
                    {{customer.Name}}
                </option>
            </select>
        </div>
    `,
    standalone: false
})
export class RegistrationRequestCustomerCellComponent implements IEntityListDynamicCellComponentGeneric<IRegistrationRequest>, OnInit {
    entity: IRegistrationRequest;
    entityListComponentMembers: IEntityListComponentMembers;
    customers: ICustomer[] = [];

    constructor(
        private customerService: CustomerService,
        private registrationRequestService: RegistrationRequestService,
        private notificationsService: NotificationsService,
        private modalService: ModalService
    ) {}

    ngOnInit(): void {
        this.loadCustomers();
    }

    shouldShowCurrentCustomer(): boolean {
        return this.entity.CustomerId > 0 && !this.customers.find(c => c.Id === this.entity.CustomerId);
    }

    loadCustomers(): void {
        if (this.customerService.getActiveCustomers) {
            this.customerService.getActiveCustomers().subscribe({
                next: (customers) => {
                    this.customers = customers || [];
                },
                error: () => {
                    this.customers = [];
                }
            });
        }
    }

    onCustomerChange(event: Event): void {
        const target = event.target as HTMLSelectElement;
        const customerId = parseInt(target.value);
        const customerName = customerId > 0 ? this.customers.find(c => c.Id === customerId)?.Name : 'None';
        
        this.modalService.showModal({
            confirmButtonText: 'Yes, Assign Customer',
            showCancelButton: true,
            cancelButtonText: 'No, Cancel',
            text: `Are you sure you want to assign customer "${customerName}" to ${this.entity.FirstName} ${this.entity.LastName}?`,
            title: 'Confirm Customer Assignment',
            icon: 'warning',
        }).subscribe((result) => {
            if (result.isConfirmed) {
                // Update the registration request
                const updatedRequest = { ...this.entity };
                updatedRequest.CustomerId = customerId === 0 ? null : customerId;
                updatedRequest.CarrierId = null;

                this.registrationRequestService.update(updatedRequest).subscribe({
                    next: () => {
                        this.entity.CustomerId = updatedRequest.CustomerId;
                        this.entity.CarrierId = null;
                        this.entity.Customer = customerId > 0 ? this.customers.find(c => c.Id === customerId) : null;
                        this.entity.Carrier = null;
                        this.notificationsService.success('Customer assigned successfully');                       
                        location.reload();      
                    },
                    error: () => {
                        this.notificationsService.error('Failed to assign customer');
                        target.value = (this.entity.CustomerId || 0).toString();
                    }
                });
            } else {
                target.value = (this.entity.CustomerId || 0).toString();
            }
        });
    }
}
